import React, { useEffect } from "react";
import useTableCtx from "../tableContext/useTableCtx";
import { tableControlBaseClasses } from "./tableControlStyles";

function FilterTable({
  value,
  withFilter,
  filterDefaultIdx,
}: {
  value: string;
  withFilter: {
    value: string | number;
    label: string | number;
  }[];
  filterDefaultIdx?: number;
}) {
  const { handleTableSearch, tableSearch } = useTableCtx()!;

  const tableSearchValue = tableSearch?.[value];
  const selectedValue = tableSearchValue ?? null;

  const filterDefaultIdxValue = filterDefaultIdx ?? 0;
  const defaultFilterValue =
    withFilter[filterDefaultIdxValue]?.value ?? withFilter[0]?.value;

  useEffect(() => {
    if (value && !tableSearchValue) {
      handleTableSearch(value, defaultFilterValue);
    }
  }, [defaultFilterValue, handleTableSearch, tableSearchValue, value]);

  const onFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleTableSearch(e.target.name, e.target.value);
  };

  return (
    <div className="relative w-full">
      {selectedValue !== null && (
        <>
          <select
            name={value}
            data-control={`select-${value}`}
            data-hide-search="true"
            className={`${tableControlBaseClasses} block w-full min-w-0 appearance-none pl-4 pr-10`}
            value={selectedValue}
            onChange={onFilterChange}>
            {withFilter.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          <span
            aria-hidden="true"
            className="pointer-events-none absolute right-4 top-1/2 h-2 w-2 -translate-y-1/2 rotate-45 border-b-2 border-r-2 border-muted-dark"
          />
        </>
      )}
    </div>
  );
}

export default FilterTable;
